import { render } from "./HeroiconsOutlineCurrencyPound.vue?vue&type=template&id=505f5fbc"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyPound.vue"]])

export default __exports__